import React, {useState} from "react";
import {useQueryClient} from "react-query";
import {Link, useNavigate} from "react-router-dom";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";

import {useGetQuery} from "../../hooks/useQueryHooks";
import {ResponseList} from "../../models/clientModels/interfaces/Response";

import {
  Box,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
} from "@mui/material";
import {alertStateAtom} from "../../Recoil/Atom/AlertAtom";
import MWSkeleton from "../../components/MWSkeleton";
import SubTitle from "../../components/SubTitle";

import {PaginationContainer} from "../../styledComponents/StyledPagination";

import * as suggestionApi from "../../api/suggestionApi/suggestionApi";
import {
  EQSuggestion,
  initializeSuggestionParam,
} from "../../models/serverModels/report/EQSuggestion";
import {StyledTableContainer, StyledTableHead} from "../../styledComponents/StyledTable";

const ListContainer = styled(Box)(({theme}) => ({
  minWidth: "1200px",
}));

const AllSuggestion = () => {
  const tokenState = useRecoilValue(tokenSelector);

  const [page, setPage] = useState<number>(1);

  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const setAlertState = useSetRecoilState(alertStateAtom);

  const {
    data: suggestionList,
    isLoading,
    isFetching,
  } = useGetQuery<ResponseList<EQSuggestion>>({
    key: ["SuggestionAll", {...initializeSuggestionParam(), token: tokenState, page}],
    api: () => suggestionApi.getAll({...initializeSuggestionParam(), token: tokenState, page}),
  });

  const paginationHandleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };
  return (
    <ListContainer>
      <SubTitle subTitle="질의 목록" />

      <StyledTableContainer>
        <Table>
          <StyledTableHead>
            <TableRow>
              <TableCell align="center">#</TableCell>
              <TableCell align="center">제목</TableCell>
              <TableCell align="center">업체</TableCell>
              <TableCell align="center">작성일자</TableCell>
              <TableCell align="center">상태</TableCell>
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {isLoading && isFetching ? (
              <MWSkeleton row={12} column={5} />
            ) : (
              suggestionList?.items.map((item, index) => (
                <TableRow key={item.uid}>
                  <TableCell align="center">
                    {page === 1
                      ? index + 1
                      : (page - 1) * initializeSuggestionParam().rows! + index + 1}
                  </TableCell>
                  <TableCell align="center">
                    <Link to={`/Suggestion/Read/${item.uid}`}>{item.title}</Link>
                  </TableCell>
                  <TableCell align="center">{item.companyName}</TableCell>

                  <TableCell align="center">
                    {new Date(item?.entryDate).getFullYear()}년
                    {new Date(item?.entryDate).getMonth() + 1}월
                    {new Date(item?.entryDate).getDate()}일
                  </TableCell>
                  <TableCell align="center">
                    {item.status === 0
                      ? "접수"
                      : item.status === 1
                      ? "미접수"
                      : item.status === 3
                      ? "완료"
                      : ""}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
      {/* 페이지네이션 */}
      <PaginationContainer>
        <Pagination
          count={suggestionList?.maxPage}
          page={page}
          onChange={paginationHandleChange}
          variant="outlined"
          color="primary"
          shape="rounded"
        />
      </PaginationContainer>
    </ListContainer>
  );
};

export default AllSuggestion;
